import { Services } from 'application/interfaces';

import shipaDelivery from './shipa-delivery';
import shipaEcommerce from './shipa-ecommerce';
import hr from './hr';
import other from './other';
import shipments from './shipments';
import workable from './workable';
import emailingService from './emailingService';
import freshworksService from './freshworksService';

const api: Services['api'] = {
  shipaDelivery,
  hr,
  shipaEcommerce,
  other,
  shipments,
  workable,
  emailingService,
  freshworksService,
};

export default api;
